export default __webpack_public_path__ + "static/media/raki_detail15.0b59b234.jpg";